export default __webpack_public_path__ + "static/media/avatar-normal-geometric-19.4ba37416.svg";